<template>
    <modal width="40" :show-modal="showModal" @close-modal="$emit('close-modal')" :styleContent="{ minWidth: '400px' }"
        :showTitle="false" :showCancleBtn="true" :showFooter="false">
        <div class="w-full">
            <div class="flex items-center gap-2 mb-4">
                <img width="20" src="../../../../../assets/images/icons/back-icon.svg" @click="goBack">
                <div>|</div>
                <h4 class="text-[#10233E] font-semibold text-[20px]"> Dispatch </h4>
            </div>
            <div class="flex justify-between ">
                <p class="flex-1">Shipments/Receiver Count : <b>{{ checkedDispatchableDetail?.length }}</b></p>
                <p class="flex-1 text-right">Item Count: <b>{{ itemcount }}</b> <b>({{ totalWeight }}Kg)</b></p>
            </div>


            <div class="flex justify-between mt-4 mb-3">
                <p class="flex-1">{{ checkedDispatchableDetail?.length }} Customers, {{ itemcount }} Packages</p>
                <button @click="togglePOD">
                    <ArrowDown fill="black" />
                </button>
            </div>
            <div v-if="isPODOpen" class=" bg-gray-200 rounded-md p-4 mb-4 overflow-auto w-full">
                <div v-for="(doc, index) in checkedDispatchableDetail" :key="index" class=" min-width_600">
                    <div class="proof-header">
                        <div class="flex-2">
                            <p class=" font-semibold text-sm">{{ doc?.receiver?.contactName || 'N/A' }}</p>
                            <p class=" text-sm text-gray-400">{{ doc?.receiver?.mobile || '' }}</p>
                        </div>

                        <p class="text-[#383F51] text-[12px] font-normal flex-1 px-3 pr-1">{{
                            doc?.receiver?.address?.address }}
                            shipment</p>
                        <p class="text-[#10233E] text-[12px] font-normal flex-1 text-center">{{ doc?.packages?.length }}
                            items</p>
                    </div>

                    <div v-if="isPODOpen">
                        <div class="table-row pl-6" v-for="(bod, index) in doc.shipments" :key="index">
                            <div>
                                <h3 class="text-[#383F51] text-[14px] font-semibold mb-2">{{ bod?.location?.contactName
                                    }}
                                </h3>
                                <h3 class="text-[#383F51] text-[12px] font-normal">{{ bod?.location?.mobile }}</h3>
                            </div>
                            <p class="text-[#383F51] text-[12px] font-normal text-center">{{
                                bod?.location?.address?.address
                                }}</p>
                            <p class="text-[#10233E] text-[12px] font-normal text-center">{{
                                bod?.shipping?.packagees?.length }} item</p>
                            <p></p>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <div class="mt-2">
                    <h3 class="text-[#10233E] text-[16px] font-normal mb-2">Route</h3>
                    <p class="text-[#383F51] text-[14px] font-normal rvcdp h-10">{{ route }}</p>
                </div>

                <div class="mt-4">
                    <h3 class="text-[#10233E] text-[16px] font-normal mb-2">Vehicle/ Carrying Capacity</h3>
                    <el-select :disabled="automaticBroadcast" v-model="dispatch.vehicle" placeholder="Select state">
                        <el-option v-for="dispatch in dispatchSummary" :key="dispatch.type"
                            :label="capitalize(dispatch.type)" :value="dispatch.type">
                        </el-option>
                    </el-select>
                </div>

                <div class="mt-1">
                    <h3 class="text-[#10233E] text-[16px] font-normal mb-2">Driver</h3>
                    <el-select :disabled="automaticBroadcast" v-model="dispatch.id" placeholder="Select state">
                        <el-option v-for="dispatch in driversOptions" :key="dispatch.id"
                            :label="capitalize(`${dispatch.user?.firstname} ${dispatch.user?.lastname}`)"
                            :value="dispatch.id">
                        </el-option>
                    </el-select>
                </div>

                <div class="mt-2">
                    <h3 class="text-[#10233E] text-[16px] font-normal mb-2">Plate Number</h3>
                    <p class="text-[#383F51] text-[14px] font-normal rvcdp h-10">{{ getVehicleInfo?.vehicleNumber
                        || "--Autoloaded--" }}</p>
                </div>
            </div>

            <div class=" flex items-center gap-2 mt-4 mb-2">
                <input class="base_checkbox" type="checkbox" v-model="automaticBroadcast" @change="setAutomaticEvent" />
                <span class=" text-sm">Enable automatic broadcast to all available riders across the platform.</span>
            </div>

            <div class="button_wrapper">
                <button @click="$emit('close-modal')">Cancel</button>
                <base-button text="Dispatch" :loading="loading" @click="createlastmileDispatch"
                    :disabled="isDisabled" />
            </div>
        </div>
    </modal>
</template>

<script>
import { userId } from "@/services/apiConfig.js";
import ArrowDown from "@/assets/images/icons/ArrowDown.vue";

export default {
    components: { ArrowDown },
    props: {
        selecetedActionShipment: {},
        showModal: {
            type: Boolean,
            required: true,
            default: false,
        },
        checkedDispatchableDetail: {
            type: Array,
            required: false,
            default: null
        },
        selecetedDispatch: {
            type: Array,
            required: false,
            default: null
        },
        fleetId: {
            type: String,
            required: false,
            default: ""
        },
    },
    data() {
        return {
            isPODOpen: false,
            loading: false,
            dispatchSummary: [],
            automaticBroadcast: false,
            dispatch: {
                vehicle: "",
                id: null
            }
        }
    },
    computed: {
        locationId() {
            return this.$store.getters.currentLocationId;
        },
        isDisabled() {
            if (this.automaticBroadcast) return false;
            return (this.dispatch.vehicle === "" || this.dispatch.id === null)
        },
        payload() {
            return {
                receiverIds: this.checkedDispatchableDetail.map((item) => item?.id),
                fleetId: this.automaticBroadcast ? null : this.dispatch?.id,
                userId: userId(),
                enableAutobroadCast: true,
                terminalId: this.locationId
            }
        },
        totalWeight() {
            return this.checkedDispatchableDetail.reduce((total, shipment) => {
                const shipmentWeight = (shipment.packages || []).reduce(
                    (sum, pkg) => sum + Number(pkg.estimatedWeight || 0),
                    0
                );

                return total + shipmentWeight;
            }, 0);
        },
        itemcount() {
            return this.checkedDispatchableDetail.reduce(
                (total, shipment) => total + (shipment.packages?.length || 0),
                0
            );
        },
        route() {
            return this.checkedDispatchableDetail.map((item) => {
                return `${item?.sender?.address?.state}-${item?.receiver?.address?.state}`
            }).join(" ")
        },
        getVehicleInfo() {
            return (this.driversOptions || []).filter((item) => item.id === this.dispatch?.id)[0]
        },
        driversOptions() {
            return (this.dispatchSummary || []).filter((item) => item.type === this.dispatch?.vehicle)[0]?.fleets
        },
        currentLocation() {
            return this.$store.getters.currentLocation;
        },

    },
    watch: {
        showModal(val) {
            if (val) {
                console.log(this.checkedDispatchableDetail)
                this.getLongHaulSummaryLastMile()
            }
        }
    },
    methods: {
        setAutomaticEvent($event) {
            this.automaticBroadcast = $event?.target?.checked
        },
        async createlastmileDispatch() {
            this.loading = true;
            try {
                const dispatch = await this.$_greateLastMileDispatch(this.payload);
                if (this.automaticBroadcast) {
                    this.generateToast('Dispatch Created Successfully', 'success')
                    this.$router.push(`/operations/dispatch/booking-confirmation/${this.checkedDispatchableDetail[0]?.shippingId}?disptchRef=${dispatch?.data?.data?.dispatch?.dispatchReference}`)
                    return;
                }
                this.$router.push('/operations/dispatch')
                this.generateToast('Dispatch Created Successfully', 'success')
            } catch (error) {
                this.handleError(error)
            } finally {
                this.loading = false;
            }
        },
        async getLongHaulSummaryLastMile() {
            try {
                this.loading = true;
                const { data: response } = await this.$_getDispatchSummaryLastMile();
                this.dispatchSummary = response.data
                console.log("dispatchSummary", this.dispatchSummary);

            } catch (error) {
                this.handleError(error);
            } finally {
                this.loading = false;
            }
        },
        togglePOD() {
            this.isPODOpen = !this.isPODOpen;
        },
        closeModal() {
            this.$emit("close-modal");
        },
        goBack() {
            this.$emit("go-back");
            this.closeModal() // Close the POD section when going back
        },

    }

};

</script>

<style scoped>
.min-width_600 {
    @apply min-w-[400px]
}

.proof-header {
    display: flex;
    justify-content: space-between;
    padding-top: 15px;
    padding-bottom: 15px;
    cursor: pointer;
}

/* Arrow rotation */
.arrow {
    display: inline-block;
    transition: transform 0.3s ease;
}

.arrow.open {
    transform: rotate(180deg);
}


.header-wrap>p {
    text-align: center;
    font-weight: 400;
    font-size: 14px;
}

.table-row {
    background: #7A90A71A;
    border-radius: 15px;
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
    padding-bottom: 10px;
    /* padding-left: 10px; */
}

.button_wrapper {
    @apply mt-7 flex justify-end gap-5
}

.rvcdp {
    background: #ebf2faa0;
    padding: 10px 0 10px 10px;
}

.base_checkbox {
    width: 1.4rem;
    height: 1.4rem;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;

    background-color: #e5e7eb;
    /* gray */
    border: none;
    cursor: pointer;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.25rem;
}

.base_checkbox:checked {
    background-color: #facc15;
    /* your yellow */
}

.base_checkbox:checked::after {
    content: "";
    margin-top: -2px;
    width: 0.35rem;
    height: 0.7rem;

    border: solid white;
    border-width: 0 2px 2px 0;

    transform: rotate(45deg);
    display: block;
}
</style>